@if (isEdit) {
  <h1 mat-dialog-title>Tilføj partner til postnummer</h1>
}
@if (!isEdit) {
  <h1 mat-dialog-title>Fjern partner fra postnummer</h1>
}
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <h2 class="form-headline margin--bottom-s">Postnummer</h2>

    <div class="flex margin--bottom-l">
      <div class="form-row form-row--inline">
        <mat-form-field appearance="outline">
          <mat-label>Fra</mat-label>
          <input type="number" matInput number formControlName="postnummerFra" />
        </mat-form-field>
      </div>
      <div class="form-row form-row--inline">
        <mat-form-field appearance="outline">
          <mat-label>Til (Valgfri)</mat-label>
          <input type="number" matInput number formControlName="postnummerTil" />
        </mat-form-field>
      </div>
    </div>
    <div>
      @if (form.get('postnummerFra').value < 1000 || form.get('postnummerFra').value > 10000) {
        <mat-error>
          Postnummer skal være imellem 1000-10000
        </mat-error>
      }
      @if (form.get('postnummerTil').hasError('max')) {
        <mat-error>Postnummer skal være under 10000</mat-error>
      }
      @if (form.get('postnummerFra').value > form.get('postnummerTil').value) {
        <mat-error>Fra skal være mindre end til</mat-error>
      }
    </div>
    <h2 class="form-headline margin--bottom-s">Vælg produkt</h2>
    <div class="form-row form-row--inline">
      <mat-button-toggle-group formControlName="produkt" aria-label="Produkt">
        @for (product of products; track product) {
          <mat-button-toggle [value]="product">
            @if (product.toLowerCase() != 'gasstorbraender') {
              <div class="icon-with-text">
                <mat-icon [svgIcon]="product.toLowerCase()"></mat-icon>
                {{ product }}
              </div>
            }
            @if (product.toLowerCase() == 'gasstorbraender') {
              <div class="icon-with-text">
                <mat-icon svgIcon="gas"></mat-icon>
                Gas Storbrænder
              </div>
            }
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>
    <h2 class="form-headline margin--bottom-s">Partner</h2>
    <div class="flex margin--bottom-l">
      <mat-form-field appearance="outline">
        <mat-select [disabled]="noPartner == true" formControlName="partner" (selectionChange)="onPartnerChange($event.value)">
          @for (partner of partnere; track partner) {
            <mat-option [value]="partner">
              {{ partner.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-checkbox formControlName="noPartner" (change)="onNoPartnerChange($event)">Område og produkt køres ikke</mat-checkbox>
      @if (isEdit) {
        <mat-checkbox formControlName="frieTilkald">Tillad frie tilkald</mat-checkbox>
      }
    </div>
    <h2 class="form-headline margin--bottom-s">Gyldighed</h2>
    <div class="flex margin--bottom-l">
      @if (isEdit) {
        <div class="form-row form-row--inline">
          <mat-form-field appearance="outline">
            <mat-label>Fra</mat-label>
            <mat-datepicker-toggle matPrefix [for]="validFromPicker"></mat-datepicker-toggle>
            <input [min]="currentDate" #validFromInput matInput [matDatepicker]="validFromPicker" formControlName="validFrom" />
            <mat-datepicker #validFromPicker></mat-datepicker>
          </mat-form-field>
        </div>
      }
      @if (!isEdit) {
        <div class="form-row form-row--inline">
          <mat-form-field appearance="outline">
            <mat-label>Til</mat-label>
            <mat-datepicker-toggle matPrefix [for]="validToPicker"></mat-datepicker-toggle>
            <input
              [min]="currentDate"
              [max]="$safeNavigationMigration(selectedPartner?.validTo)"
              #validToInput
              matInput
              [matDatepicker]="validToPicker"
              formControlName="validTo"
              />
              <mat-datepicker #validToPicker></mat-datepicker>
            </mat-form-field>
          </div>
        }
      </div>
    </form>
  </div>

  <div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Fortryd</button>
    <button [disabled]="!form.valid" mat-raised-button color="primary" (click)="save()">Gem</button>
  </div>
